export const homeFeatures = [
  {
    id: 'feature-1',
    title: '智能搜索与推荐',
    description: '基于先进 AI 算法的精准内容匹配，让您快速找到所需服务，节省宝贵时间。',
    icon: 'ri-search-eye-line',
  },
  {
    id: 'feature-2',
    title: '多维安全防护',
    description: '银行级加密技术与多重身份验证，全方位守护您的账户和数据安全。',
    icon: 'ri-shield-check-line',
  },
  {
    id: 'feature-3',
    title: '高效数据处理',
    description: '强大的数据处理引擎，支持大规模数据的快速导入、清洗、分析和可视化。',
    icon: 'ri-database-2-line',
  },
  {
    id: 'feature-4',
    title: '多端无缝同步',
    description: '桌面端与移动端数据实时同步，随时随地享受一致的服务体验。',
    icon: 'ri-smartphone-line',
  },
  {
    id: 'feature-5',
    title: '即时通讯协作',
    description: '内置即时通讯系统，支持文字、文件、图片等多种消息类型，团队协作更高效。',
    icon: 'ri-chat-3-line',
  },
  {
    id: 'feature-6',
    title: '智能数据分析',
    description: '丰富的可视化图表和分析工具，将复杂数据转化为直观洞察。',
    icon: 'ri-bar-chart-2-line',
  },
];

export const homeAdvantages = [
  {
    id: 'adv-1',
    title: '安全可靠',
    description: '通过 ISO 27001 认证，采用 AES-256 加密标准，全方位保障用户数据安全。',
    icon: 'ri-shield-star-line',
  },
  {
    id: 'adv-2',
    title: '高效便捷',
    description: '平均页面响应低于 1.5 秒，智能流程设计让复杂操作变得简单直观。',
    icon: 'ri-flashlight-line',
  },
  {
    id: 'adv-3',
    title: '全面覆盖',
    description: '一站式整合多项核心服务，满足个人用户和企业客户的多样化需求。',
    icon: 'ri-stack-line',
  },
  {
    id: 'adv-4',
    title: '专业服务',
    description: '7×24 小时客户支持，专业团队快速响应，确保您的每一次使用体验。',
    icon: 'ri-customer-service-2-line',
  },
];

export const homeStats = [
  { label: '累计注册用户', value: '500万+', icon: 'ri-user-3-line' },
  { label: '日均处理请求', value: '2亿+', icon: 'ri-cloud-line' },
  { label: '服务可用率', value: '99.99%', icon: 'ri-check-double-line' },
  { label: '覆盖国家地区', value: '180+', icon: 'ri-global-line' },
];

export const homeFAQs = [
  {
    question: 'qiaojzx.cn 是免费的吗？',
    answer: 'qiaojzx.cn 提供基础免费服务和高级付费服务。免费版已覆盖核心功能，满足大多数个人用户日常使用。如需解锁更多高级功能，可选择专业版或企业版。',
  },
  {
    question: '如何在 qiaojzx.cn 上注册账号？',
    answer: '访问 qiaojzx.cn 官网，点击右上角"注册"按钮，填写用户名、邮箱或手机号码、设置密码，完成验证后即可成功注册。详细步骤请参考"注册登录教程"分类下的文章。',
  },
  {
    question: '忘记密码了怎么找回？',
    answer: '在登录页面点击"忘记密码"，通过绑定的手机号码或电子邮箱接收验证码，验证通过后即可重置密码。重置链接有效期为 30 分钟。',
  },
  {
    question: 'qiaojzx.cn 支持哪些支付方式？',
    answer: '目前支持支付宝、微信支付、银联在线支付以及企业银行转账（企业版）。更多支付方式持续接入中。',
  },
  {
    question: '数据在 qiaojzx.cn 上安全吗？',
    answer: '绝对安全。qiaojzx.cn 采用银行级 AES-256 加密标准，全站启用 TLS 1.3 协议，已通过 ISO 27001 信息安全管理体系认证，全方位保护您的数据安全。',
  },
  {
    question: '可以同时在多台设备上登录吗？',
    answer: '可以。qiaojzx.cn 支持多设备同时登录，所有数据实时同步。您可以在"账户设置"中查看和管理所有已登录设备。',
  },
];